import { render, staticRenderFns } from "./feeBasicData.vue?vue&type=template&id=6211a3a2&"
import script from "./feeBasicData.vue?vue&type=script&lang=js&"
export * from "./feeBasicData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports